const SvgIconCollateral = (props) => (
  <svg viewBox="0 0 120 105" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M120 0v105H93.87V52.5c0-14.503-11.694-26.25-26.13-26.25-14.437 0-26.13 11.747-26.13 26.25V105H15.478V0H120Z"
      fill="#29A964"
    />
    <path
      d="M58.137 63.51c0-16.053-13.015-29.067-29.069-29.067S0 47.457 0 63.51v41.314h58.137V63.511Z"
      fill="#EFAC26"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.48 37.807a28.94 28.94 0 0 1 13.587-3.364 28.933 28.933 0 0 1 16.082 4.85 26.23 26.23 0 0 0-3.54 13.206V105H15.48V37.807Z"
      fill="#3763FF"
    />
  </svg>
);

export default SvgIconCollateral;
